@use "ui/styles/colors";

.wrapper {
  & *,
  & {
    cursor: pointer;
  }

  text-decoration: none;
  color: currentcolor;
  transition: all 0.2s;

  // Ensure SVG icons maintain their size
  svg {
    flex-shrink: 0;
  }

  > svg:first-child:not(:only-child) {
    margin-right: 9px;
  }
}

.disabled {
  & *,
  & {
    cursor: not-allowed;
    color: colors.$gray60;
  }
}

.selected {
  color: colors.$blue;

  * {
    color: colors.$blue;
  }
}
